import { KeyRound, UserRound } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { cn } from '../../lib/utils'

export function UserMenu() {
  const { session } = useAuth()
  const [open, setOpen] = useState(false)
  const [imageFailed, setImageFailed] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  const initials = session?.user
    ? `${session.user.first_name.charAt(0)}${session.user.surname.charAt(0)}`.toUpperCase()
    : 'HRS'

  const imageUrl = session?.user?.image ?? null
  const showPhoto = Boolean(imageUrl) && !imageFailed

  useEffect(() => {
    setImageFailed(false)
  }, [imageUrl])

  useEffect(() => {
    if (!open) {
      return
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        aria-label="User Menu"
        aria-expanded={open}
        aria-haspopup="menu"
        className={cn(
          'grid h-8 w-8 place-items-center overflow-hidden rounded-full bg-green-600 text-sm font-semibold text-white',
          'transition hover:ring-2 hover:ring-green-600/30 focus:outline-none focus:ring-2 focus:ring-green-600/40',
        )}
        onClick={() => setOpen((value) => !value)}
      >
        {showPhoto ? (
          <img
            src={imageUrl!}
            alt=""
            className="h-full w-full object-cover"
            onError={() => setImageFailed(true)}
          />
        ) : (
          initials
        )}
      </button>

      {open && (
        <div
          role="menu"
          className="absolute top-[calc(100%+0.5rem)] right-0 z-50 min-w-[12rem] overflow-hidden rounded-md border border-parch-100 bg-white py-1 shadow-lg"
        >
          <Link
            to="/profile"
            role="menuitem"
            className="flex items-center gap-2 px-3 py-2 text-sm text-ink-700 hover:bg-parch-50"
            onClick={() => setOpen(false)}
          >
            <UserRound className="h-4 w-4" />
            Profile
          </Link>
          <Link
            to="/update-credentials"
            role="menuitem"
            className="flex items-center gap-2 px-3 py-2 text-sm text-ink-700 hover:bg-parch-50"
            onClick={() => setOpen(false)}
          >
            <KeyRound className="h-4 w-4" />
            Update Credentials
          </Link>
        </div>
      )}
    </div>
  )
}
